import React, {useContext, useEffect, useState} from 'react';
import { Balloon, Button, NumberPicker, Radio } from '@alifd/next';
import {ActivityContext} from '../../index';
import styles from '../../index.module.scss';
import CONSTANTS from '../../constant';
import SelectGoods from '@/components/SelectGoods';
import LzMsg from '@/components/common/LzMsg';
import AreaChoose from '../AreaChoose';

function GoalSetting() {
  const { task, taskParams, setTaskParams, type, pageDisable, refresh } = useContext(ActivityContext);
  const [orderAmountType, setOrderAmountType] = useState(0); //订单金额类型 0不限制 1条件输入
  const [skuNumType, setSkuNumType] = useState(0); //商品数量类型 0不限制 1条件输入
  const [selectGoodsVisible, setSelectGoodVisible] = useState(false);
  const [selectGoods, setSelectGoods] = useState([]);
  
  useEffect(()=>{
    if(type!=='create') {
      taskParams.orderCondition.orderAmount === '0-0' ? '' : setOrderAmountType(1)
      taskParams.orderCondition.skuNum === '0-0' ? '' : setSkuNumType(1)
    }
  },[refresh])
  /**
   * 选择商品完毕关闭弹窗
   */
  const confirm = (v) => {
    if(v.length > 300) {
      LzMsg.error('最多可选择300个商品!');
      return
    }
    let newOrderCondition = {...taskParams.orderCondition}
    setTaskParams({ 
      ...taskParams,
      orderCondition:{
        ...newOrderCondition,
        skuConfig:{
          ...newOrderCondition.skuConfig,
          ids:v
        }
      }
    })
    setSelectGoodVisible(false);
  };

  /**
   * 地区子组件传值给父组件
   */
  const ChooseArea = (value) => {
    let tempList = [];
    value.forEach((item) => {
      tempList.push(item.toString());
    });
    let newAreaCondition = {...taskParams.areaCondition}
    setTaskParams({ 
      ...taskParams,
      areaCondition:{
        ...newAreaCondition,
        ids:tempList
      }
    })
  };
  const chooseAreaType = (value) => {
    let newAreaCondition = {...taskParams.areaCondition}
    setTaskParams({ 
      ...taskParams,
      areaCondition:{
        ...newAreaCondition,
        ids:[],
        type:value
      }
    })
  };
  // useEffect(()=>{
  //   let newOrderCondition = {...taskParams.orderCondition}
  //   setTaskParams({ 
  //     ...taskParams,
  //     orderCondition:{
  //       ...newOrderCondition,
  //       skuConfig:{
  //         ...newOrderCondition.skuConfig,
  //         selectGoods,
  //       }
  //     }
  //   })
  // },[selectGoods])
  return (
    <div>
      {/* 条件关系 */}
      <div className={styles['cardBox']} style={{marginBottom:'10px'}}>
        <div className={styles['titleBox']}>
          订单限制：
        </div>
        <div className={styles['goalBoxLine']}>
          条件关系 
          <Button.Group>
            <Button
              type={taskParams.orderCondition.conditionRelation === 1 ? 'primary' : 'normal'}
              disabled={pageDisable && taskParams.orderCondition.conditionRelation !== 1}
              className={styles['btnRadius']}
              style={{cursor: pageDisable ? 'no-drop':''}}
              onClick={() => {
                let newOrderCondition = {...taskParams.orderCondition}
                setTaskParams({ 
                  ...taskParams,
                  orderCondition:{
                    ...newOrderCondition,
                    conditionRelation:1
                  }
                })
              }}
            >
              且
            </Button>
            <Button
              type={taskParams.orderCondition.conditionRelation === 2 ? 'primary' : 'normal'}
              disabled={pageDisable && taskParams.orderCondition.conditionRelation !== 2}
              className={styles['btnRadius1']}
              style={{cursor: pageDisable ? 'no-drop':''}}
              onClick={() => {
                let newOrderCondition = {...taskParams.orderCondition}
                setTaskParams({ 
                  ...taskParams,
                  orderCondition:{
                    ...newOrderCondition,
                    conditionRelation:2
                  }
                })
              }}
            >
              或
            </Button>
          </Button.Group>
        </div>
      </div>
      {/* 订单状态 */}
      <div className={styles['goalGaryBoxLine']}>
        订单状态:
        <div>
          <Button.Group>
            {
              CONSTANTS.ORDER_STATUS_LIST.map((item,index)=>{
                return (
                  <Button
                    key={item.value}
                    disabled={item.value !== taskParams.orderCondition.orderStatus}
                    style={{cursor: pageDisable ? 'no-drop':''}}
                    type='primary'
                    className={styles[`${item.value === 1 ?'btnRadius': item.value === 6 ? 'btnRadius1' : ''}`]}
                  >
                    <Balloon.Tooltip
                      key={item.value}
                      align='t'
                      trigger={item.label}
                    >
                      {item.tips}{item.value !== taskParams.orderCondition.orderStatus && '该关怀场景不支持选择此状态'}
                    </Balloon.Tooltip>
                  </Button> 
                )
              })
            }
          </Button.Group>
        </div>
      </div>
      {/* 订单类型 */}
      <div className={styles['goalGaryBoxLine']} style={{position:'relative'}}>
        订单类型:
        <div>
          <Radio.Group
            value={taskParams.orderCondition.orderType}
            onChange={(v) => {
              let newOrderCondition = {...taskParams.orderCondition}
              setTaskParams({ 
                ...taskParams,
                orderCondition:{
                  ...newOrderCondition,
                  orderType:v
                }
              })
            }}
            disabled={pageDisable}
          >
            <Radio value={0} disabled={CONSTANTS.ACTIVITY_TYPE_DATA[task].orderTypeList.findIndex((item)=>item === 0)===-1} style={{width:80}}>
              <div className={styles['radioSmallBox']}>  
                {
                  CONSTANTS.ACTIVITY_TYPE_DATA[task].orderTypeList.findIndex((item)=>item === 0)===-1 ?
                  <Balloon.Tooltip
                    align='t'
                    trigger='全部订单'
                  >
                    {CONSTANTS.ACTIVITY_TYPE_DATA[task].orderTypeList.findIndex((item)=>item === 0)===-1 && '此场景不支持该类型。'}
                  </Balloon.Tooltip>
                  : '全部订单'
                }
              </div>
            </Radio>
            <Radio value={1} disabled={CONSTANTS.ACTIVITY_TYPE_DATA[task].orderTypeList.findIndex((item)=>item === 1)===-1}>
              <div className={styles['radioSmallBox']}>
                <Balloon.Tooltip
                  align='t'
                  trigger='在线支付'
                >
                  指先付款后发货的订单。{CONSTANTS.ACTIVITY_TYPE_DATA[task].orderTypeList.findIndex((item)=>item === 1)===-1 && '此场景不支持该类型。'}
                </Balloon.Tooltip>
              </div>
            </Radio>
            <Radio value={2} disabled={CONSTANTS.ACTIVITY_TYPE_DATA[task].orderTypeList.findIndex((item)=>item === 2)===-1}>
              <div className={styles['radioSmallBox']}>
                <Balloon.Tooltip
                  align='t'
                  trigger='货到付款'
                >
                  指先发货，确认收货再付款的订单。{CONSTANTS.ACTIVITY_TYPE_DATA[task].orderTypeList.findIndex((item)=>item === 2)===-1 && '此场景不支持该类型。'}
                </Balloon.Tooltip>
              </div>
            </Radio>
          </Radio.Group>
        </div>
        <div className={styles.CircleBox}>{taskParams.orderCondition.conditionRelation === 1 ? '且' : '或'}</div>
      </div>
      {/* 订单金额 */}
      <div className={styles['goalGaryBoxLine']} style={{position:'relative'}}>
        <Balloon.Tooltip
          align='t'
          trigger={<div className={`${styles['iconStyle']} iconfont icon-icon4-33`}/>}
        >
          消费者支付的实际金额
        </Balloon.Tooltip>
        订单金额:
        <div>
          <Radio.Group
            value={orderAmountType}
            onChange={(v) => {
              setOrderAmountType(+v);
              let newOrderCondition = {...taskParams.orderCondition}
              setTaskParams({ 
                ...taskParams,
                orderCondition:{
                  ...newOrderCondition,
                  orderAmount:v===0?'0-0':'0-9999999.99'
                }
              })
            }}
            disabled={pageDisable}
          >
            <Radio value={0} style={{width:80}} >
              <div className={styles['radioSmallBox']}>  
               不限制
              </div>
            </Radio>
            <Radio value={1}>
              <div className={styles['radioSmallBox']}>
                金额区间
                <NumberPicker
                  min={0}
                  max={9999999.99}
                  precision={2}
                  hasTrigger={false}
                  disabled={pageDisable || orderAmountType !==1}
                  value={orderAmountType === 0 ? '' : taskParams.orderCondition.orderAmount.split('-')[0]}
                  style={{width:'100px'}}
                  onChange={(v) => {
                    let newOrderCondition = {...taskParams.orderCondition}
                    setTaskParams({ 
                      ...taskParams,
                      orderCondition:{
                        ...newOrderCondition,
                        orderAmount:`${(v||v===0) ? v : ''}-${newOrderCondition.orderAmount.split('-')[1]}`
                      }
                    })
                  }}
                />
                至
                <NumberPicker
                  min={0}
                  max={9999999.99}
                  precision={2}
                  hasTrigger={false}
                  disabled={pageDisable ||orderAmountType !==1}
                  value={orderAmountType === 0 ? '' : taskParams.orderCondition.orderAmount.split('-')[1]}
                  style={{width:'100px'}}
                  onChange={(v) => {
                    let newOrderCondition = {...taskParams.orderCondition}
                    setTaskParams({ 
                      ...taskParams,
                      orderCondition:{
                        ...newOrderCondition,
                        orderAmount:`${newOrderCondition.orderAmount.split('-')[0]}-${(v||v===0) ? v : ''}`
                      }
                    })
                  }}
                />
                元
              </div>
            </Radio>
          </Radio.Group>
        </div>
        <div className={styles.CircleBox1}>{taskParams.orderCondition.conditionRelation === 1 ? '且' : '或'}</div>
      </div>
      {/* 商品限制 */}
      <div className={styles['goalGaryBoxLine']} style={{position:'relative'}}>
        <Balloon.Tooltip
          align='t'
          trigger={<div className={`${styles['iconStyle']} iconfont icon-icon4-33`}/>}
        >
          订单中包含的商品
        </Balloon.Tooltip>
        商品限制:
        <div>
          <Radio.Group
            value={taskParams.orderCondition.skuConfig.type}
            onChange={(v) => {
              setSelectGoods([]);
              let newOrderCondition = {...taskParams.orderCondition}
              setTaskParams({ 
                ...taskParams,
                orderCondition:{
                  ...newOrderCondition,
                  skuConfig:{
                    ...newOrderCondition.skuConfig,
                    type:v,
                    ids:[]
                  }
                }
              })
            }}
            disabled={pageDisable}
          >
            <Radio value={1} style={{width:80}}>
              <div className={styles['radioSmallBox']}>  
                全部商品
              </div>
            </Radio>
            <Radio value={2}>
              <div className={styles['radioSmallBox']}>
                指定商品
                {
                  taskParams.orderCondition.skuConfig.type ===2 &&
                  <Button
                    type='secondary'
                    size='small'
                    style={{borderRadius:'5px'}}
                    onClick={()=>setSelectGoodVisible(true)}
                    disabled={pageDisable}
                  >
                    选择商品({taskParams.orderCondition.skuConfig.ids.length}/300)
                  </Button>
                }
              </div>
            </Radio>
            <Radio value={3}>
              <div className={styles['radioSmallBox']}>
                排除商品
                {
                  taskParams.orderCondition.skuConfig.type ===3 &&
                  <Button
                    type='secondary'
                    size='small'
                    style={{borderRadius:'5px'}}
                    onClick={()=>setSelectGoodVisible(true)}
                    disabled={pageDisable}
                  >
                    选择商品({taskParams.orderCondition.skuConfig.ids.length}/300)
                  </Button>
                }
              </div>
            </Radio>
          </Radio.Group>
        </div>
        <div className={styles.CircleBox}>{taskParams.orderCondition.conditionRelation === 1 ? '且' : '或'}</div>
      </div>
      {/* 商品数量 */}
      <div className={styles['goalGaryBoxLine']}>
        <Balloon.Tooltip
          align='t'
          trigger={<div className={`${styles['iconStyle']} iconfont icon-icon4-33`}/>}
        >
          订单中所有商品的数量总计
        </Balloon.Tooltip>
        商品数量:
        <div>
          <Radio.Group
            disabled={pageDisable}
            value={skuNumType}
            onChange={(v) => {
              setSkuNumType(+v);
              let newOrderCondition = {...taskParams.orderCondition}
              setTaskParams({ 
                ...taskParams,
                orderCondition:{
                  ...newOrderCondition,
                  skuNum:v===0?'0-0':'1-999999'
                }
              })
            }}
          >
            <Radio value={0} style={{width:80}}>
              <div className={styles['radioSmallBox']}>  
               不限制
              </div>
            </Radio>
            <Radio value={1}>
              <div className={styles['radioSmallBox']}>
                数量区间
                <NumberPicker
                  min={1}
                  max={999999}
                  hasTrigger={false}
                  disabled={pageDisable || skuNumType !==1}
                  style={{width:'100px'}}
                  value={skuNumType === 0 ? '' : taskParams.orderCondition.skuNum.split('-')[0]}
                  onChange={(v) => {
                    let newOrderCondition = {...taskParams.orderCondition}
                    setTaskParams({ 
                      ...taskParams,
                      orderCondition:{
                        ...newOrderCondition,
                        skuNum:`${v ? v : ''}-${newOrderCondition.skuNum.split('-')[1]}`
                      }
                    })
                  }}
                />
                至
                <NumberPicker
                  min={1}
                  max={999999}
                  hasTrigger={false}
                  disabled={pageDisable || skuNumType !==1}
                  style={{width:'100px'}}
                  value={skuNumType === 0 ? '' : taskParams.orderCondition.skuNum.split('-')[1]}
                  onChange={(v) => {
                    let newOrderCondition = {...taskParams.orderCondition}
                    setTaskParams({ 
                      ...taskParams,
                      orderCondition:{
                        ...newOrderCondition,
                        skuNum:`${newOrderCondition.skuNum.split('-')[0]}-${v ? v : ''}`
                      }
                    })
                  }}
                />
                件
              </div>
            </Radio>
          </Radio.Group>
        </div>
      </div>
      {/* 地区限制 */}
      {/* <div className={styles['cardBox']} style={{marginBottom:'10px'}}>
        <div className={styles['titleBox']}>
          地区限制：
        </div>
        <div className={styles['goalBoxLine']}>
          <Radio.Group
            value={taskParams.areaCondition.type}
            onChange={(v) => {
              let newAreaCondition = {...taskParams.areaCondition}
              setTaskParams({ 
                ...taskParams,
                areaCondition:{
                  ...newAreaCondition,
                  type:v,
                  ids:v===1 ? [] : newAreaCondition.ids
                }
              })
            }}
          >
            <Radio value={1} style={{width:80}}>
              <div className={styles['radioSmallBox']}>  
                全部地区
              </div>
            </Radio>
            <Radio value={2}>
              <div className={styles['radioSmallBox']}>
                指定地区
                {
                  taskParams.areaCondition.type ===2 &&
                  <Button
                    type='secondary'
                    size='small'
                    style={{borderRadius:'5px'}}
                  >
                    选择地区
                  </Button>
                }
              </div>
            </Radio>
            <Radio value={3}>
              <div className={styles['radioSmallBox']}>
                排除地区
                {
                  taskParams.areaCondition.type ===3 &&
                  <Button
                    type='secondary'
                    size='small'
                    style={{borderRadius:'5px'}}
                  >
                    选择地区
                  </Button>
                }
              </div>
            </Radio>
          </Radio.Group>
        </div>
      </div> */}
      <AreaChoose
        handlerClick={ChooseArea}
        chooseAreaType={chooseAreaType}
        //  传值对象
        area={taskParams.areaCondition}
        pageStatus={type === 'view' ? 2 : type === 'edit' ? 3 : 1} // 1是新建，2是查看，3是复制
        clearAll={() => {
          let newAreaCondition = {...taskParams.areaCondition}
          setTaskParams({ 
            ...taskParams,
            areaCondition:{
              ...newAreaCondition,
              ids:[]
            }
          })
        }}
      />
      <SelectGoods
        goodsDialog={selectGoodsVisible}
        closeDialog={() => setSelectGoodVisible(false)}
        skuIds={taskParams.orderCondition.skuConfig.ids}
        confirmSkuid={(v) => confirm(v)}
        selectGoods={selectGoods}
        confirmGoods={(v) => {
          setSelectGoods(v);
        }}
      />
    </div>
  );
}

export default GoalSetting;
